exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-field {\n  width:200px;\n  /* margin: 0 0 40px 0;*/\n  /* float: left; */\n}\n.file-field .btn { width: 100%; float: none; }\n.file-field .example-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  color: #ffffff;\n}\n.img-error { position: absolute; bottom: -20px;}\n.ink-img { max-height:300px; }\n.ink-img img { max-width:100%; max-height:300px; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-users/profile/profile.component.css
// module id = ../../../../../src/app/mnt-users/profile/profile.component.css
// module chunks = common